<template>
  <div style="padding: 0 10px">
    <Form @search="searchCall" :regionList="regionList"></Form>
    <div style="margin-bottom: 20px; text-align: left">
      <el-button type="primary" @click="createGridCode">批量新增</el-button>
      <el-button type="primary" @click="confirmPrint()">批量打印</el-button>
    </div>
    <WmsTable :columns="columns" :dataSource="dataSource" @pageChange="pageChangeCall" :isRowSelection="true" @selectChange="selectChange" :isPagination="query" >
      <div slot="action" slot-scope="{ text, record }"
        style="display: flex; justify-content: center; align-items: center">
        <!-- <a href="javascript:;" style="padding: 0 10px" @click="edit(record)"
          >编辑</a
        > -->
        <a href="javascript:;" style="padding: 0 10px" @click="confirmPrint(record)">打印</a>
      </div>
    </WmsTable>
    <SetGridCode ref="SetGridCode" :regionList="regionList" @submit="saveGrids" />
    <el-dialog
      title="选择打印尺寸"
      :visible.sync="dialogVisible"
      width="400px"
    >
      <div>
        <el-radio v-model="templatePrint" label="1">放大版本</el-radio>
        <el-radio v-model="templatePrint" label="2">8cm适用</el-radio>
        <el-radio v-model="templatePrint" label="3">原始版本</el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="ok">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Form from "@/views/configure/gridCode/components/Form";
import SetGridCode from "@/views/configure/gridCode/components/SetGridCode";
import WmsTable from "@/components/WmsTable";
import { columns } from "@/views/configure/gridCode/indexData";
import { gridPageList, getRegionList, gridSave } from "@/apis/configure";
import { templatePrintByGridcode } from "@/utils/print"
export default {
  title: "货格码",
  name: "ConfigureGridCode",
  components: {
    SetGridCode,
    WmsTable,
    Form,
  },
  data() {
    return {
      columns,
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
      regionList: [],
      selList:[],
      fromData: {},
      templatePrint: '1',
      activeRecord: {},
      isBatch: false,
      dialogVisible: false
    };
  },
  mounted() {
    this.getDataSource();
    this.getRegionList();
  },
  methods: {
    searchCall: function (fromData) {
      this.fromData = fromData
      this.query.current = 1;
      this.query.total = 1;
      this.getDataSource();
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },

    getDataSource: function (fromData) {
      let params = {
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        ...this.fromData
      };
      if (fromData) {
        params.regionCode = fromData.regionCode;
      }
      gridPageList(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
    createGridCode: function () {
      this.$refs["SetGridCode"].open();
    },
    confirmPrint(record){
      if(!record?.id && !this.selList.length) {
        this.$message.warning("请勾选");
        return
      }
      this.activeRecord = record || {}
      this.isBatch = !record?.id
      this.templatePrint = '1'
      this.dialogVisible = true
    },
    printAll: function () {
      templatePrintByGridcode(this.selList, this.templatePrint)
    },
    ok(){
      if(this.isBatch) {
        this.printAll()
      }else {
        this.printCode(this.activeRecord)
      }
      this.dialogVisible = false
    },
    edit: function () {
      this.$message.warning("开发中");
    },
    printCode: function (record) {
      templatePrintByGridcode([record], this.templatePrint)
    },

    saveGrids(r) {
      gridSave(r).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("添加成功");
          this.getDataSource();
        }
      });
    },

    getRegionList() {
      getRegionList().then(({ code, data }) => {
        if (code === 0) {
          this.regionList = data;
        }
      });
    },

    selectChange(rows){
      console.log(rows)
      this.selList = rows
    },
  },
};
</script>

<style scoped>
</style>
